<template>
  <div id="report" class="container">
    <div class="row dado__head">
      <div class="col-12 col-lg-3">
        <div class="title">Surve Report</div>
      </div>
    </div>
    <div class="row">
      <v-sidebar/>
      <div class="col-12 col-lg-10">
        <div class="dado__array mb-4 p-4 font14">
          <div class="row">
            <div class="col-2">
              <div class="font-weight-bold mb-2">Start</div>
              <div>{{ getResult.start }}</div>
            </div>
            <div class="col-2">
              <div class="font-weight-bold mb-2">Finish</div>
              <div>{{ getResult.finish }}</div>
            </div>
            <div class="col-2">
              <div class="font-weight-bold mb-2">Time</div>
              <div>{{ getResult.time }} hrs</div>
            </div>
            <div class="col-3">
              <div class="font-weight-bold mb-2">Monitor</div>
              <div>{{ getResult.monitor }} - {{ getResult.partner }}</div>
            </div>
            <div class="col-3">
              <button v-if="map" class="login__btn" @click="showMap">Show Map</button>
            </div>
          </div>
        </div>
        <div class="dado__array">
          <div class="dado__bred p-4">
            <template v-for="question in getResult.data">
              <div class="questions__output">
                <span class="questions__bill" v-if="sizeNumberQuestion(question.number)" v-html="sizeNumberQuestion(question.number)"></span>
                <span class="text-dark">{{ question.text }}</span>
              </div>
              <div class="questions__checkbox p-0">
                <div v-for="answer in question.answers">
                  <label class="checkbox">
                    <input type="checkbox" checked disabled>
                    <span class="checkbox__part">
                      <span class="checkbox__text text-success">{{ answer.text }} {{ answer.concentration }}</span>
                    </span>
                  </label>

                  <template v-if="answer.childrens">
                    <div class="pl-4">
                      <div v-for="children of answer.childrens">
                        <div class="questions__output opacity50" style="flex-wrap: wrap;">
                          <span class="questions__bill" v-html="sizeNumberQuestion(children.number)"></span>
                          <span class="text-dark">{{ children.text }}</span>
                          <div class="w-100 mt-3" v-for="answer of children.answers">
                            <label class="checkbox">
                              <input type="checkbox" checked disabled>
                              <span class="checkbox__part">
                                <span class="checkbox__text text-dark">{{ answer }}</span>
                              </span>
                            </label>
                          </div>
                          <div class="text-muted font-weight-light font-italic" v-if="children.comment">{{ children.comment }}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <hr>
              <div class="text-muted font-italic">{{ question.comment }}</div>
              <div v-if="question.photos.length">
                <div class="priviews">
                  <vue-previewer :images="question.photos" mode="image" :options="{defaultWidth: '50px',defaultHeight: '50px',thumbnailStyle: {backgroundSize: 'cover'}}"/>
                </div>
              </div>
            </template>
          </div>
          <div class="dado__bred p-4" v-if="getResult.organs">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th>Summary results table Pesticide</th>
                <th>Answer to Q20</th>
                <th></th>
              </tr>
              <tr>
                <th>System</th>
                <th>Max. score</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) of getResult.organs">
                <td>{{ index + 1 }}. {{ item.system }}</td>
                <td class="text-center">{{ item.score }}</td>
                <td class="w-50"></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="dado__bred p-4" v-if="getResult.concentration">
            <table class="table table-hover table-bordered">
              <thead>
              <tr>
                <th class="text-center">Pesticide</th>
                <th class="text-center">Concentration reported on the label</th>
                <th class="text-center">Quantity used</th>
                <th class="text-center">How many litres of water used for dilution</th>
                <th class="text-center">Final concentration expressed in g/l</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-center">{{ getResult.concentration.pesticide }}</td>
                <td class="text-center">{{ getResult.concentration['C1'] }}</td>
                <td class="text-center">{{ getResult.concentration['V1'] }}</td>
                <td class="text-center">{{ getResult.concentration['V2'] }}</td>
                <td class="text-center">{{ getResult.concentration['final'] }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'Result',
    props: ['id'],
    computed: {
      ...mapGetters([
        'getResult',
        'getAuthUser',
      ]),
      map() {
        return !!(this.getResult.coords && this.getResult.coords.lan && this.getResult.coords.lng);
      }
    },
    mounted() {
      this.queryResult(this.id)
    },
    methods: {
      ...mapActions([
        'queryResult',
        'showModal',
      ]),
      sizeNumberQuestion(number) {
        if (!number)
          return false
        if (number.length > 3)
          number = '<small>' + number + '</small>'
        return number
      },
      showMap() {
        this.showModal({
          modal: 'ModalMap', data: {
            lat: this.getResult.coords.lan,
            lng: this.getResult.coords.lng,
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  #report {
    .priviews {
      img {
        border-radius: 3px;
        margin: 10px 10px 10px 0;
      }
    }
  }
</style>